import * as React from 'react';

export function useIntlFormat(region = 'en-au'): Intl.DateTimeFormat {
    return React.useMemo(() => Intl.DateTimeFormat(region), [region]);
}
